module.exports = __webpack_public_path__ + "img/h4.d12fc208.png";